import React, { useContext,useEffect, useState } from "react";
import { makeStyles,useTheme } from "@material-ui/core/styles";
import {
	Typography,
	Paper,
	Grid,
	Button
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';

import { UserContext } from "../../contexts/UserContext";
import { PageContext } from "../../contexts/PageContext";
import MfaProfileSettings from "../auth/MfaProfileSettings";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 700,
		marginLeft: "auto",
		marginRight: "auto"
	},
	settingsGroup: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		marginTop: "20px"
	},
	marginR: {
		marginRight: "15px;"
	}
})); 

export default function Profile(props) {



	const theme = useTheme();
	const classes = useStyles();
	const userContext = useContext(UserContext);
	const pageContext = useContext(PageContext);
	const isBackoffice = userContext.user.role === "backoffice";

	useEffect(()=>{
		setUserData({ID: userContext.user.ID, name: userContext.user.name, email: userContext.user.email, role: userContext.user.role})
	}, [userContext])

	const [editName, setEditName] = useState(false);
	const [editEmail, setEditEmail] = useState(false);
	const [editPassword, setEditPassword] = useState(false);
	const [userData, setUserData] = useState({ID: 0, name:"", email:"", role:"", password:"", new_password:""});

	const [errMsg, setErrMsg] = useState('');

	const validatePassword = (e) => {

		if(e.target.value.length < 10) {
			setErrMsg('Das Passwort muss mindestens 10 Zeichen lang sein.')
		} else {
			setErrMsg('')
			setUserData({...userData, new_password: e.target.value})
		}
    };

	const patchUser = (patchUser) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/users/${patchUser.ID ? patchUser.ID : ''}`,
			data: {
				name: patchUser.name,
				email: patchUser.email,
				role: patchUser.role,
				password: patchUser.password,
				new_password: patchUser.new_password
			},
			method: 'patch',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				pageContext.setInfoMessage("Benutzer wurde aktualisiert");
				setUserData({...userData, password: "", new_password: ""})
			})
			.catch((err) => {
				if(err.request.response){
					pageContext.setErrorMessage("Das Passwort ist falsch.");
				} else {
					pageContext.setErrorMessage("Benutzer konnte nicht aktualisiert werden!");
				}
			});
	}

	return (
		<div className={classes.root}>
			<Typography variant="h2">Profil</Typography>
			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						{ editName ? 
							 <TextField 
							 	id="standard-basic"
								label="Name"
								defaultValue={userData.name}
								onChange={(e)=>{
									setUserData({...userData, name: e.target.value})
								}}
							/>
							:
							<Typography>Name: <span data-testid="user-name">{userData.name}</span></Typography>
						}
					</Grid>
					<Grid item xs={6} >
						<Button  
							className={classes.marginR}
							variant="outlined"
							startIcon={<EditIcon />}
							onClick={()=>{
								setEditName(!editName)
							}}
						>
							{editName ? "abbrechen" : "Bearbeiten"}
						</Button>
						{ editName ?
							<Button 
								className={classes.marginR}
								variant="outlined"
								startIcon={<SaveIcon />}
								onClick={()=>{
									setEditName(false)
									patchUser(userData)
								}}
							>
								Speichern
							</Button>
							:
							""
						}
						
					</Grid>
					<Grid item xs={6}>
						{ editEmail ? 
							<TextField 
								id="standard-basic"
								label="Name"
								defaultValue={userData.email}
								onChange={(e)=>{
									setUserData({...userData, email: e.target.value})
								}}
							/>
							:
							<Typography>E-Mail: <span data-testid="user-email">{userData.email}</span></Typography>
						}
					</Grid>
					<Grid item xs={6} >
						<Button  
							className={classes.marginR}
							variant="outlined"
							startIcon={<EditIcon />}
							onClick={()=>{
								setEditEmail(!editEmail)
							}}
						>
							{editEmail ? "abbrechen" : "Bearbeiten"}
						</Button>
						{ editEmail ?
							<Button 
								className={classes.marginR}
								variant="outlined"
								startIcon={<SaveIcon />}
								onClick={()=>{
									setEditEmail(false)
									patchUser(userData)
								}}
							>
								Speichern
							</Button>
							:
							""
						}
					</Grid>
					<Grid item xs={12}>
						{ isBackoffice && editPassword ? 
							<>
								<Grid item xs={12} >
									<TextField 
										id="standard-basic"
										label="Altes Passwort"
										onChange={
											(e)=>{
												setUserData({...userData, password: e.target.value})
											}
										}
									/>
								</Grid>
								<Grid item xs={12} >
									<TextField 
										error={errMsg ? true : false}
										helperText={errMsg}
										id="standard-basic"
										label="Neues Passwort"
										onChange={(e)=>{
											validatePassword(e)
										}}
									/>
								</Grid>
							</>
							:
							null
						}
					</Grid>
					<Grid item xs={12} >
						{isBackoffice && <Button  
							className={classes.marginR}
							variant="outlined"
							startIcon={<EditIcon />}
							onClick={()=>{
								setEditPassword(!editPassword)
							}}
						>
							{editPassword ? "abbrechen" : "Passwort ändern"}
						</Button>
						}
						{ isBackoffice && editPassword ?
							<Button  
							className={classes.marginR}
							variant="outlined"
							startIcon={<SaveIcon />}
							onClick={()=>{
								setEditPassword(false)
								patchUser(userData)
							}}
							>
								Speichern
							</Button>
							:
							null
						}
					</Grid>
				</Grid>
			</Paper>
			<MfaProfileSettings />
		</div>
	);
}
